import AuthenticationState from "~/state/AuthenticationState";

export async function login(checkoutAsGuest = true) {
  return new Promise((resolve, reject) => {
    if (AuthenticationState.helpers.isSignedIn())
      return resolve(AuthenticationState.helpers.getUser());

    const subscriptions = {};

    function onEndSignIn() {
      unSubscribeEvents();
      reject();
    }

    function onSignInSuccess() {
      unSubscribeEvents();
      resolve(AuthenticationState.helpers.getUser());
    }

    function unSubscribeEvents() {
      subscriptions.checkoutAsGuest.unsubscribe();
      subscriptions.signInSuccess.unsubscribe();
      subscriptions.endSignIn.unsubscribe();
    }

    subscriptions.signInSuccess = AuthenticationState.events.signInSuccess.subscribe(
      onSignInSuccess
    );
    subscriptions.checkoutAsGuest = AuthenticationState.events.checkoutAsGuest.subscribe(
      onEndSignIn
    );
    subscriptions.endSignIn = AuthenticationState.events.endSignIn.subscribe(
      onEndSignIn
    );
    AuthenticationState.events.beginSignIn.next(checkoutAsGuest);
  });
}
